import { DialogActions, DialogContentText, DialogContent, Dialog, DialogTitle, Button} from '@material-ui/core';

interface ISuccessDialogProps {
  open: boolean,
  title: string,
  content: string,
  onClose: () => void;
}

export const  SuccessDialog = (props: ISuccessDialogProps) => {
  return (
    <Dialog 
      onClose={() => {props.onClose()}} 
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-text"
      open={props.open}
    >
      <DialogTitle id="alert-dialog-title">
        {props.title ? props.title : ''} 
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-text">
          {props.content ? props.content : ''} 
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button 
          color="primary"
          variant="outlined"
          onClick={() => {props.onClose()}} 
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
